<div class="button-container">
    <button mat-icon-button class="actions-buttons" [disabled]="disabled || showSpinner">
        <mat-icon [matTooltip]="hint" (click)="doAction()" class="actions-mat-icons">
            {{icon}}
        </mat-icon>
    </button>
    <app-process-small-spinner class="embedded-spinner" *ngIf="showSpinner" [isVisible]="true">
    </app-process-small-spinner>
</div>
